import type { ExperienceAtfPromoVariant } from '../constants';

/** Amplitude `label` for ATF promo cards; shared by click and view so values cannot drift. */
export function formatAtfPromoEventLabel(promoVariant: ExperienceAtfPromoVariant): string {
  return `ATF_${promoVariant}`;
}
